var __jsx = React.createElement;
import * as React from "react";
var CardGroupIcon = function CardGroupIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 80,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.428,
    height: 58.58,
    x: 2.774,
    y: 0.56,
    strokeWidth: 4,
    rx: 7.376,
    transform: "rotate(-33.566 48.997 14.501) skewX(.044)",
    className: "fill-[#D9DBDD] stroke-[#BBBFC2] dark:fill-gray-900 sm:dark:fill-[#29333E] dark:stroke-[#474F58]"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.439,
    height: 58.567,
    x: 2.425,
    y: 1.457,
    strokeWidth: 4,
    rx: 7.376,
    transform: "rotate(-14 75.09 -58.826) skewX(.022)",
    className: "fill-[#D9DBDD] stroke-[#BBBFC2] dark:fill-gray-900 sm:dark:fill-[#29333E] dark:stroke-[#474F58]"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.099,
    height: 59.509,
    x: 39.638,
    y: 14.899,
    strokeWidth: 4,
    rx: 7.376,
    transform: "rotate(-.026 39.638 14.9)",
    className: "fill-[#D9DBDD] stroke-[#BBBFC2] dark:fill-gray-900 sm:dark:fill-[#29333E] dark:stroke-[#474F58]"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-[#BBBFC2] dark:fill-[#474F58]",
    d: "m115.878 53.292-6.016 1.705 5.354 6.809c.372.472.29 1.142-.149 1.512l-2.444 2.004c-.455.374-1.112.28-1.479-.175l-5.087-6.465-3.481 6.444c-.463.859-1.673.641-1.924-.242L93.74 40.537c-.264-.93.737-1.703 1.51-1.215l20.836 12.005c.83.449.671 1.716-.208 1.965Z"
  }));
};
export default CardGroupIcon;